import { FOOTER_SIMILAR_JOBS_COUNT, SIDEBAR_SIMILAR_JOBS_COUNT } from '../constants';

export const getSimilarJobsQueryLimit = (hasSidebarJobs: boolean) => {
  return hasSidebarJobs ? SIDEBAR_SIMILAR_JOBS_COUNT + FOOTER_SIMILAR_JOBS_COUNT : FOOTER_SIMILAR_JOBS_COUNT;
};
